import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  Chip,
  Button
} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const StepItem = ({ title, desc, status, time }) => {

  const getStatusColor = () => {
    if (status === "Completed") return "#22c55e";
    if (status === "Running") return "#3b82f6";
    return "#999";
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 2,
        borderRadius: 3,
        border: "1px solid #eee",
        mb: 2
      }}
    >
      {/* LEFT */}
      <Box display="flex" alignItems="center" gap={2}>
        <RadioButtonUncheckedIcon sx={{ color: "#e5e5e5" }} />

        <Box>
          <Typography fontWeight={600}>{title}</Typography>
          <Typography fontSize={13} color="text.secondary">
            {desc}
          </Typography>
        </Box>
      </Box>

      {/* RIGHT */}
      <Box display="flex" alignItems="center" gap={2}>

        <Chip
          label={status}
          size="small"
          sx={{
            bgcolor: `${getStatusColor()}20`,
            color: getStatusColor(),
            fontWeight: 500
          }}
        />

        {time && (
          <Box
            sx={{
              width: 55,
              height: 55,
              borderRadius: "50%",
              border: `4px solid #f26522`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              fontWeight: 600
            }}
          >
            {time}
          </Box>
        )}
      </Box>
    </Box>
  );
};

const PayrollPipeline = () => {
  return (
    <Card  className="h-100"
sx={{ borderRadius: "3px",    border: "1px solid #eee",
 }}>
      <CardContent>

        {/* HEADER */}
        <Box display="flex" justifyContent="space-between" mb={3}>
          <Typography fontWeight={700} fontSize={18}>
          
                   <h6 fontSize={17}  ><strong> Payroll Processing Pipeline</strong></h6>

          </Typography>

          <Chip
            label="Processing 4 to 6"
            size="small"
            sx={{
              bgcolor: "#fee2e2",
              color: "#ef4444"
            }}
          />
        </Box>

        {/* PROGRESS */}
        <Box mb={3}>
          <Box display="flex" justifyContent="space-between">
            <Typography fontSize={14}>Overall Progress</Typography>
            <Typography fontSize={13} color="text.secondary">
              (40%)
            </Typography>
          </Box>

          <LinearProgress
            variant="determinate"
            value={40}
            sx={{
              mt: 1,
              height: 10,
              borderRadius: 5,
              bgcolor: "#eee",
              "& .MuiLinearProgress-bar": {
                bgcolor: "#0f4c5c"
              }
            }}
          />
        </Box>

        {/* STEPS */}
        <StepItem
          title="Data Validation"
          desc="All employee records validated"
          status="Completed"
          time="2 Min"
        />

        <StepItem
          title="Attendance Calculation"
          desc="Working days and hours calculated"
          status="Completed"
          time="4 Min"
        />

        <StepItem
          title="Salary Computation"
          desc="Base salary + allowances calculated"
          status="Completed"
          time="3 Min"
        />

        <StepItem
          title="Deductions Processing"
          desc="Tax, PF, and other deductions"
          status="Running"
        />

        <StepItem
          title="Final Verification"
          desc="Admin approval required"
          status="Pending"
        />

        <StepItem
          title="Payment Generation"
          desc="Bank file creation"
          status="Pending"
        />

        {/* BUTTONS */}
        <Box display="flex" gap={2} mt={3}>
          <Button
            fullWidth
            variant="contained"
            sx={{
              borderRadius: 50,
              bgcolor: "#f26522",
              textTransform: "none"
            }}
          >
            Continue Processing
          </Button>

          <Button
            fullWidth
            variant="outlined"
            sx={{
              borderRadius: 50,
              textTransform: "none"
            }}
          >
            Export Report
          </Button>
        </Box>

      </CardContent>
    </Card>
  );
};

export default PayrollPipeline;